import { createReducer } from '@src/redux/helpers/createReducer';

import { SET_DENTAL } from './constants';

const initialState = {
  isDental: false,
};

export const dentalReducer = createReducer(initialState, {
  [SET_DENTAL]: (state, action) => {
    return {
      ...state,
      isDental: action.payload,
    };
  },
});
